import { User } from '@sr/types';
import React, { useState } from 'react';
import { Button, Input, NModal } from '../../ui';
import API from '../../utils/api';

const ChangeNameModal = ({ user }: { user: User }) => (
  <NModal title="Change Name" OpenButton={<OpenButton />}>
    <ModalContent user={user} />
  </NModal>
);

function ModalContent({
  user,
  closeModal,
}: {
  closeModal?: () => void;
  user: User;
}) {
  const [data, setData] = useState({
    firstName: user.firstName,
    lastName: user.lastName,
  });
  function handleChange(e: React.FormEvent<HTMLInputElement>) {
    const el = e.currentTarget;
    setData({ ...data, [el.name]: el.value });
  }
  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const { firstName = '', lastName = '' } = data;
    API.user
      .changeName({ userId: user.id, firstName, lastName })
      .then(() => closeModal && closeModal());
  }
  return (
    <form onSubmit={handleSubmit} id="gi-change-name-modal">
      <Input
        placeholder="First Name"
        value={data.firstName}
        name="firstName"
        onChange={handleChange}
        autoFocus
        required
      />
      <Input
        placeholder="Last Name"
        value={data.lastName}
        name="lastName"
        onChange={handleChange}
        required
      />
      <Button variant="primary" mt={3} type="submit">
        Save Changes
      </Button>
    </form>
  );
}

function OpenButton({ onClick }: { onClick?: () => void }) {
  return (
    <Button
      onClick={onClick}
      sx={{
        variant: 'buttons.link',
        pl: 0,
        py: 0,
        lineHeight: '32px',
      }}
      id="gi-open-change-name"
    >
      Change name
    </Button>
  );
}

export default ChangeNameModal;
